const parseEnvVar = arg =>
  JSON.parse(process.env[arg]?.replace(/_/g, ' ') || '{}')

const processTables = () => {
  let tables = parseEnvVar('ADLIB_AIRTABLE_TABLES')

  if (Array.isArray(tables)) {
    tables = tables.map(table => ({
      ...table,
      baseId: process.env['ADLIB_AIRTABLE_BASE_ID'],
      tableView: 'CMS',
      // add defaultValues to resources table
      defaultValues:
        table['tableType'] === 'resources'
          ? {
              Filter_1: [''],
              Filter_2: [''],
              Filter_3: [''],
              Filter_4: [''],
              Filter_5: [''],
              Filter_6: [''],
              Filter_7: [''],
              Filter_8: [''],
              List_1: [''],
              List_2: [''],
              List_3: [''],
              List_4: [''],
              List_5: [''],
              List_6: [''],
              Text_1: '',
              Text_2: '',
              Text_3: '',
              Text_4: '',
              Text_5: '',
              Text_6: '',
            }
          : undefined,
    }))
  } else {
    tables = []
  }
  return tables
}

module.exports = {
  plugins: [
    {
      resolve: `gatsby-source-airtable`,
      options: {
        apiKey: process.env.ADLIB_AIRTABLE_KEY,
        tables: processTables(),
        concurrency: 5,
      },
    },
    {
      resolve: 'talus-gatsby-site-map',
      options: parseEnvVar('ADLIB_SITEMAP'),
    },
    {
      resolve: `gatsby-plugin-gtag`,
      options: {
        trackingId: 'G-XV49YEYYF3',
        anonymize: true,
        head: false,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'pages',
        path: './src/pages/',
      },
      __key: 'pages',
    },
    'gatsby-plugin-root-import',
    'gatsby-plugin-styled-components',
    'talus-gatsby-transformer-svg',
    'gatsby-plugin-react-helmet',
    'gatsby-transformer-sharp',
    'gatsby-plugin-sharp',
    'gatsby-plugin-image',
    'gatsby-plugin-sass',
    'gatsby-plugin-mdx',
  ],
}
